import { rect, aRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Part } from '../../types';

// Anchor = waist line (x=32, y~36 for average)
// Bottoms overwrite the leg area of the body

export const bottoms: Record<string, Part> = {
  bottom_pants: {
    id: 'bottom_pants', category: 'bottom', name: 'Pants', requires: SLOT.WAIST,
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y, 14, 3, p.detail);          // waistband
      rect(ctx, a.x - 7, a.y + 3, 6, 15, p.detail);   // left leg
      rect(ctx, a.x + 1, a.y + 3, 6, 15, p.detail);   // right leg
      rect(ctx, a.x - 7, a.y + 4, 1, 14, p.detailDark);// left outer seam
      rect(ctx, a.x + 6, a.y + 4, 1, 14, p.detailDark);// right outer seam
      aRect(ctx, a.x, a.y, 14, 1, p.dark);             // waist top edge
    },
  },
  bottom_shorts: {
    id: 'bottom_shorts', category: 'bottom', name: 'Shorts', requires: SLOT.WAIST,
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y, 14, 3, p.detail);
      rect(ctx, a.x - 7, a.y + 3, 6, 7, p.detail);    // left short leg
      rect(ctx, a.x + 1, a.y + 3, 6, 7, p.detail);    // right short leg
      aRect(ctx, a.x, a.y + 9, 12, 1, p.detailDark);   // hem
      aRect(ctx, a.x, a.y, 14, 1, p.dark);
    },
  },
  bottom_skirt: {
    id: 'bottom_skirt', category: 'bottom', name: 'Skirt', requires: SLOT.WAIST,
    draw: (ctx, a, p) => {
      // A-line skirt — widens toward hem
      aRect(ctx, a.x, a.y, 14, 2, p.detail);           // waistband
      aRect(ctx, a.x, a.y + 2, 14, 3, p.detail);
      aRect(ctx, a.x, a.y + 5, 16, 3, p.detail);
      aRect(ctx, a.x, a.y + 8, 18, 3, p.detail);
      aRect(ctx, a.x, a.y + 11, 20, 3, p.detail);
      aRect(ctx, a.x, a.y + 13, 20, 1, p.detailDark);  // hem
      aRect(ctx, a.x, a.y, 14, 1, p.dark);
    },
  },
  bottom_cargo: {
    id: 'bottom_cargo', category: 'bottom', name: 'Cargo', requires: SLOT.WAIST,
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y, 14, 3, p.detail);
      rect(ctx, a.x - 7, a.y + 3, 6, 15, p.detail);
      rect(ctx, a.x + 1, a.y + 3, 6, 15, p.detail);
      // Cargo pockets
      rect(ctx, a.x - 7, a.y + 5, 5, 5, p.dark);       // left pocket
      rect(ctx, a.x + 2, a.y + 5, 5, 5, p.dark);       // right pocket
      rect(ctx, a.x - 7, a.y + 5, 5, 1, p.detailDark); // pocket top
      rect(ctx, a.x + 2, a.y + 5, 5, 1, p.detailDark);
      aRect(ctx, a.x, a.y, 14, 1, p.dark);
    },
  },
  bottom_tights: {
    id: 'bottom_tights', category: 'bottom', name: 'Tights', requires: SLOT.WAIST,
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y, 14, 2, p.detailDark);        // waistband
      rect(ctx, a.x - 7, a.y + 2, 6, 16, p.accent);    // left leg
      rect(ctx, a.x + 1, a.y + 2, 6, 16, p.accent);    // right leg
      rect(ctx, a.x - 6, a.y + 3, 1, 14, p.accentLight);// left highlight
      rect(ctx, a.x + 2, a.y + 3, 1, 14, p.accentLight);// right highlight
    },
  },
  bottom_kilt: {
    id: 'bottom_kilt', category: 'bottom', name: 'Kilt', requires: SLOT.WAIST,
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y, 14, 2, p.accent);            // waistband
      aRect(ctx, a.x, a.y + 2, 14, 13, p.detail);
      // Plaid pattern
      rect(ctx, a.x - 6, a.y + 2, 1, 13, p.accent);
      rect(ctx, a.x - 2, a.y + 2, 1, 13, p.accent);
      rect(ctx, a.x + 2, a.y + 2, 1, 13, p.accent);
      rect(ctx, a.x + 6, a.y + 2, 1, 13, p.accent);
      aRect(ctx, a.x, a.y + 5, 14, 1, p.detailDark);
      aRect(ctx, a.x, a.y + 9, 14, 1, p.detailDark);
      aRect(ctx, a.x, a.y + 14, 14, 1, p.dark);        // hem
    },
  },
  bottom_robe: {
    id: 'bottom_robe', category: 'bottom', name: 'Robe', requires: SLOT.WAIST,
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y, 14, 2, p.detailDark);
      aRect(ctx, a.x, a.y + 2, 14, 4, p.detail);
      aRect(ctx, a.x, a.y + 6, 16, 4, p.detail);
      aRect(ctx, a.x, a.y + 10, 18, 4, p.detail);
      aRect(ctx, a.x, a.y + 14, 20, 5, p.detail);
      aRect(ctx, a.x, a.y + 18, 20, 1, p.detailDark);  // hem
    },
  },
  bottom_mini: {
    id: 'bottom_mini', category: 'bottom', name: 'Mini', requires: SLOT.WAIST,
    draw: (ctx, a, p) => {
      aRect(ctx, a.x, a.y, 14, 2, p.accent);
      aRect(ctx, a.x, a.y + 2, 14, 5, p.detail);
      aRect(ctx, a.x, a.y + 6, 14, 1, p.detailDark);   // hem
    },
  },
};
